module.exports = __webpack_public_path__ + "static/media/IMG_0803.2771c600.jpg";